import styles from './Alert.module.css';

interface AlertProps {
  children: React.ReactNode;
  variant?: 'success' | 'danger' | 'warning' | 'info';
}

const variantMap: Record<string, string> = {
  success: styles.alertSuccess,
  danger: styles.alertDanger,
  warning: styles.alertWarning,
  info: styles.alertInfo,
};

export function Alert({ children, variant = 'info' }: AlertProps) {
  return (
    <div className={`${styles.alert} ${variantMap[variant]}`}>
      {children}
    </div>
  );
}
